import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import { getPricingName, getPricingDataById } from "../../../../../../components/helper/helper";

function Surcharge({ appData }) {
  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
      </ul>

      {/* Surcharge Rates */}
      <div>
        {/* <HeadingWithLine text="Pin-Based Debit" /> */}
        <ul>
          <li>
            <div>
              <p>Surcharge Rate</p>
              <p>{getPricingDataById(appData, 35).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>$ {getPricingDataById(appData, 35).dollars}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Monthly Fee</p>
              <p>$ {getPricingDataById(appData, 17).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Pin Based Debit */}
      <div>
        <HeadingWithLine text={`Pin-Based Debit${appData?.billing?.network_fee === "no" ? " (Disabled)" : ""}`} />
        <ul>
          <li>
            <div>
              <p>Network Fee</p>
              <p>{appData?.billing?.network_fee == 'yes' ? "Yes" : "No"}</p>
            </div>
          </li>
        </ul>
        <ul>
          <li>
            <div>
              <p>Debit Rate</p>
              <p>{getPricingDataById(appData, 5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>$ {getPricingDataById(appData, 5).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Debit Structure */}
      <div>
        <HeadingWithLine text="Debit Structure" />
        <ul>
          <li>
            <div>
              <p>Debit Structure</p>
              <p>IC Plus</p>
            </div>
          </li>
        </ul>
      </div>

      {appData.pricing_model == "tiered" ? (
        <div>
          <ul>
            <li>
              <div>
                <p>Qualified Debit Rate</p>
                <p>{getPricingDataById(appData, 39).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>Qualified Txn Fee</p>
                <p>$ {getPricingDataById(appData, 39).dollars}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Mid - Qualified Debit Rate</p>
                <p>{getPricingDataById(appData, 40).percent != null && getPricingDataById(appData, 40).percent !== "" ? `${getPricingDataById(appData, 40).percent}%` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Mid - Qualified Txn Fee</p>
                <p>{getPricingDataById(appData, 40).dollars != null && getPricingDataById(appData, 40).dollars !== "" ? `$ ${getPricingDataById(appData, 40).dollars}` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Non - Qualified Debit Rate</p>
                <p>{getPricingDataById(appData, 41).percent != null && getPricingDataById(appData, 41).percent !== "" ? `${getPricingDataById(appData, 41).percent}%` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>Non - Qualified Txn Fee</p>
                <p>{getPricingDataById(appData, 41).dollars != null && getPricingDataById(appData, 41).dollars !== "" ? `$ ${getPricingDataById(appData, 41).dollars}` : "-"}</p>
              </div>
            </li>
          </ul>
        </div>
      ) : (
        <div>
          <ul>
            <li>
              <div>
                <p>IC+ Debit Rate</p>
                <p>{getPricingDataById(appData, 6).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>IC+ Txn Fee</p>
                <p>$ {getPricingDataById(appData, 6).dollars}</p>
              </div>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default Surcharge;
